import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppConfigService } from "src/app-config.service";
import { GeneralService } from "src/app/service/general-service";
import { OrderService } from "src/app/service/order-service";
import { ShareaService } from "src/app/service/sharea.service";

@Component({
  selector: "app-print-double-test",
  templateUrl: "./print-double-test.component.html",
  styleUrls: ["./print-double-test.component.scss"],
  providers: [OrderService],
})
export class PrintDoubleTestComponent implements OnInit {
  orderItem: any = {
    patient: {},
  };

  groupResultValues = [];
  orderId: any;
  resultValues: any = {
    dateTaken: "",
    dateReceived: "",
    order: {
      gestationalWeek: 0,
      gestationalDay: 0,
    },
  };
  barcode = "";
  status: string = "";
  lstConfigPrintOrder = {
    address: "",
    backgroundLogo: "",
    ceo: "",
    conductor: "",
    doctor: "",
    logo: "",
    money: "",
    professionalCouncil: "",
    responsible: "",
    result: "",
  };
  printId: any;

  urlHeader: string = "";
  urlBackground: string = "";
  datas: any[] = [];
  orderCode: any;

  dataTable1: any[] = [];
  dataTable2: any[] = [];

  constructor(
    private orderService: OrderService,
    private router: ActivatedRoute,
    private generalService: GeneralService,
    private configService: AppConfigService,
    private shareaService: ShareaService
  ) {}

  ngOnInit(): void {
    this.router.queryParams.subscribe((params) => {
      this.printId = params.id;
      this.orderCode = params.orderCode;
      this.lstConfigPrintOrder = {
        address: JSON.parse(params.address),
        backgroundLogo: JSON.parse(params.backgroundLogo),
        ceo: JSON.parse(params.ceo),
        conductor: JSON.parse(params.conductor),
        doctor: JSON.parse(params.doctor),
        logo: JSON.parse(params.logo),
        money: JSON.parse(params.money),
        professionalCouncil: JSON.parse(params.professionalCouncil),
        responsible: JSON.parse(params.responsible),
        result: JSON.parse(params.result),
      };
    });
    console.log(this.lstConfigPrintOrder);
    this.getDataTable();
    this.getHeader();
  }

  getDataTable() {
    this.orderService.getOrderResultValueByOrdCode(this.orderCode).subscribe(
      (res) => {
        if (res !== null) {
          this.resultValues = res;
          res.datas.filter((en) => {
            if (
              en.orderTypeName == 'Free Beta HCG (Cobas)' || 
              en.orderTypeName == 'PAPP-A (Cobas)' ||  
              en.orderTypeName == 'Khoảng sáng sau gáy (NT)' 
            ) {
              this.dataTable1.push(en)
            }
          })
          res.datas.filter((en) => {
            if (
              en.orderTypeName == "Hội chứng Down (Trisomy 21)" ||
              en.orderTypeName == "Hội chứng Edwards (Trisomy 18)" ||
              en.orderTypeName == "Hội chứng Patau (Trisomy 13)" ||
              en.orderTypeName == "Hội chứng Down (theo tuổi mẹ)"
            ) {
              this.dataTable2.push(en);
            }
          });
          let itemHCG = this.dataTable1.find(
            (en) => en.orderTypeName == "Free Beta HCG (Cobas)" && en.unitName == "MoM"
          );
          let itemPAPP = this.dataTable1.find(
            (en) => en.orderTypeName == "PAPP-A (Cobas)" && en.unitName == "MoM"
          );
          this.dataTable1 = this.dataTable1.map((p) =>
            p.value == "Free Beta HCG (Cobas)"
              ? { ...p, valueMoM: itemHCG.valueStr }
              : p
          );
          this.dataTable1 = this.dataTable1.map((p) =>
            p.value == "PAPP-A (Cobas)"
              ? { ...p, valueMoM: itemPAPP.valueStr }
              : p
          );
          this.dataTable1 = this.dataTable1.filter(
            (en) => en.unitName !== "MoM"
          );
          console.log(this.dataTable1, this.dataTable2);
        }
      },
      (error) => {}
    );
  }

  getHeader() {
    this.orderService.getOrderById(this.printId).subscribe(
      (res) => {
        this.orderItem = res;
        this.urlHeader =
          this.configService.getConfig().api.baseUrl +
          "/" +
          this.orderItem.partner?.headerLogo;
        this.urlBackground =
          this.configService.getConfig().api.baseUrl +
          "/" +
          this.orderItem.partner?.backgroundLogo;
      },
      (error) => {}
    );
  }

  getGroupResultValue(data) {
    this.orderService.getOrderResultValues(data).subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);
          this.resultValues = res;
          this.groupResultValues = res.data;
          console.log(this.groupResultValues);
        }
      },
      (error) => {}
    );
  }

  toTdCls(item: any) {
    if (item.resultType.unitType === 0) {
      const val = +item.valueStr;
      if (val < item.resultType.normalMin || val > item.resultType.normalMax) {
        return "result-abnormal";
      }
      return "result-normal";
    } else {
      return "";
    }
  }

  exportPdf() {
    const titlePrint = "";
    const printContents = document.getElementById(`print-div`).innerHTML;
    let styleCommon = this.shareaService.getStyleCommonPrint();
    const content = `
    <html>
    <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>${titlePrint}</title>
    <style>
      ${styleCommon}
      body {
        font-family: serif;
      }

      .logo-background {
        position: absolute;
        top: 0%;
        left: 0%;
        width: 100%;
        margin: auto;
        display: block;
        opacity: 0.1;
        margin-top: 260px;
      }

      .link-info {
        text-decoration: underline;
        color: #2e8acb;
      }

      .content-header {
        font-weight: 900;
        color: #2e8acb;
      }

      .logo {
        padding-left: 2rem;
      }

      .print-wrapper {
        width: 42%;
        margin: 16px auto;
        position: relative;
      }

      h1,
      p,
      div {
        margin: 0;
        padding: 0;
      }

      h1 {
        margin-bottom: 10px;
        text-transform: uppercase;
        font-size: 32px;
        font-weight: 900;
        color: #2e8acb;
      }

      h2 {
        font-weight: 900;
      }

      .row-info {
        display: flex;
        text-align: center;
        width: 90%;
        margin: 5px auto 0;
        span,
        p {
          flex: 2 1 auto;
        }
        padding-left: 50px;
      }


      .table-result {
        border: solid 1px rgb(0, 0, 0);
      }

      .table-result td,
      .table-result th:not(:last-child):after {
        padding: 3px 10px;
        border-right: solid 1px rgb(0, 0, 0);
        border-bottom: solid 1px rgb(0, 0, 0);
        color: #333;
        font-size: 16px;
        font-family: serif;
      }

      .table-result th {
        border-bottom: solid 1px rgb(0, 0, 0);
        text-align: center;
      }

      .result-abnormal td.color-change {
        color: red;
        font-weight: bold;
      }

      .info {
        font-family: serif;
      }

      .info td,
      th {
        font-size: 16px;
      }

      .info-contact p {
        text-align: center;
      }

      .sign {
        display: flex;
        text-transform: uppercase;
        justify-content: space-around;
        font-family: serif;
        font-weight: bold;
        margin-top: 1rem;
        height: 150px;
        font-size: 16px;
        margin-left: 3.2rem;
        margin-bottom: 1rem;
      }

      .sign > table > tr > td {
        font-weight: bold;
      }

      .content-footer:first-child {
        margin-bottom: 1rem;
      }
      .print-wrapper {
        width: 100%;
      }
      .date-sign {
          text-align: end;
          padding-right: 26px;
          font-family: serif;
          font-style: italic;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 20px;
      }
      
      .note p {
          font-weight: 600;
          font-style: italic;
      }

      .header-table {
          font-family: serif;
          font-size: 15px;
          font-weight: bold;
          margin: 20px;
          margin-bottom: 0px;
      }
    </style>
    </head>
    <body onload='window.print()'>${printContents}</body>
    </html>`;

    const payload = {
      html: content,
      orderId: this.printId,
      paperSize: "A4",
    };
    this.generalService.exportPDF(payload).subscribe((res) => {
      if (res.isValid) {
        const link = document.createElement("a");
        // link.download = res.jsonData;
        link.setAttribute("download", res.jsonData);
        // link.href =
        //   this.configService.getConfig().api.baseUrl +
        //   "/api/Prescription/GetPdf/" +
        //   this.prescription.Id +
        //   "/" +
        //   res.jsonData;
        // if (!this.isMobile) {
        //   link.target = "_blank";
        // }
        link.click();
      }
    });
  }
}
